const dataAbout = [
    {
        id: 1,
        title: 'Always back you up',
        desc: 'Once there is a trade, the tax will transfer BUSD to the Vault Contract, such that we can maintain a least price of the token',
        class: 'active'
    },
    {
        id: 2,
        title: 'Buying Taxes',
        desc: '6% add LP reward, 2% burning, 2% marketing',
    },
    {
        id: 3,
        title: 'Selling Taxes',
        desc: '6% add LP reward, 4% vault',
    },
]

export default dataAbout;